import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';

const Tab = ({ children, isActive, onClick, onClose }) => {
  const truncatedText = typeof children === 'string' ? children.slice(0, 20) + (children.length > 20 ? '...' : '') : children;

  return (
    <div
      className={`app-tab mr-1 group ${isActive ? 'app-tab-active' : 'app-tab-inactive'}`}
    >
      <div
        className="flex-grow truncate cursor-pointer font-medium relative z-10"
        onClick={onClick}
      >
        {truncatedText}
      </div>
      {onClose && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          className={`
            ml-1 rounded-full p-1 relative z-10 transition-all duration-200 ease-in-out
            ${isActive
              ? 'text-white/80 hover:bg-white/20 hover:text-white'
              : 'text-slate-400 opacity-0 group-hover:opacity-100 hover:bg-slate-300/60 hover:text-slate-700'
            }
          `}
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default Tab;
